import type { IrrelevantReasonItem } from '../types'

interface IrrelevantReasonsChartProps {
  breakdown: IrrelevantReasonItem[]
}

export function IrrelevantReasonsChart({ breakdown }: IrrelevantReasonsChartProps) {
  if (breakdown.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
        <h3 className="text-sm font-medium text-gray-500 mb-4">Top Irrelevant Reasons</h3>
        <p className="text-sm text-gray-400 text-center py-8">No irrelevant calls in this period</p>
      </div>
    )
  }

  // Take top 5 reasons
  const topReasons = breakdown.slice(0, 5)

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
      <h3 className="text-sm font-medium text-gray-500 mb-4">Top Irrelevant Reasons</h3>

      <div className="space-y-3">
        {topReasons.map((item, index) => (
          <div key={item.reason}>
            <div className="flex items-center justify-between mb-1">
              <span className="text-sm text-gray-700">{item.label}</span>
              <span className="text-sm font-medium text-gray-900">{item.percentage}%</span>
            </div>
            <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
              <div
                className="h-full bg-red-400 rounded-full transition-all duration-300"
                style={{ width: `${item.percentage}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
